import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import * as moment from 'moment';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
@Component({
    selector: 'app-wallet',
    templateUrl: './wallet.component.html',
    styleUrls: ['./wallet.component.css']
})
export class WalletComponent implements OnInit {

    displayedColumnsCwallets = [
        'userEmail',
        'walletType',
        'currency',
        'availableBalance',
        'balance',
        'updatedAt'
    ];
    public dataSourceCwallets: any = new MatTableDataSource();
    @ViewChild('paginatorCwallets', { read: MatPaginator }) paginatorCwallets: MatPaginator;
    @ViewChild('sortCwallets', { read: MatSort }) sortCwallets: MatSort;
    pageSize = 10;
    pageSize1 = 5;
    filter: any;
    pageSizeCwallets = 5;
    currentPage = 0;
    currentPage1 = 0;
    vaultId: any;
    userId: any;
    currentPageCwallets = 0;
    pageSizeOptionsCwallets: number[] = [5, 10, 25, 50, 100];
    constructor(private userService: UserService,
        private route: ActivatedRoute,
        private dialog: MatDialog,
    ) {
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSourceCwallets.filter = filterValue;
    }
    async pageChangedCwallets(event: PageEvent) {
        this.pageSizeCwallets = await event.pageSize;
        this.currentPageCwallets = await event.pageIndex;
    }
    ngOnInit() {
        this.userId = this.route.snapshot.paramMap.get('id');
        this.getVaultDetails();
    }

    async createWalletByUser() {
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                message: `Are you sure want to create wallet?`,
                buttonText: {
                    ok: 'Yes',
                    cancel: 'No'
                }
            }
        }).afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                this.userService.createWalletByUser(this.userId).subscribe(res => {
                })
            }
        });
    }
    async exportArray() {
        if (this.dataSourceCwallets.filteredData) {
            const wallet = await this.dataSourceCwallets.filteredData.map(x => ({
                currency: x.currency,
                availableBalance: x.availableBalance,
                balance: x.balance,
                // createdAt: x.createdAt,
            }));
            TableUtil.exportArrayToExcel(wallet, "wallet");
        }

    }
    applyRefreshData() {
        this.getVaultDetails();
    }
    getVaultDetails() {
        if (this.userId) {
            this.userService.getCwalUser(this.userId).subscribe(Cwallets => {               
                let CwalletsRes = Cwallets.wallist.map(wallet => {
                    wallet.updatedAt = moment(wallet.updatedAt).format('MM/DD/YY h:mm:ss A');
                    wallet.userid = wallet.userid;
                    wallet.currency = wallet.currency;
                    wallet.availableBalance = wallet.availableBalance;
                    wallet.balance = wallet.balance;
                    return wallet;
                })
                if (CwalletsRes) {
                    this.dataSourceCwallets = new MatTableDataSource(CwalletsRes);
                    this.dataSourceCwallets.paginator = this.paginatorCwallets;
                    this.dataSourceCwallets.sort = this.sortCwallets;
                } else {
                    this.dataSourceCwallets = new MatTableDataSource([])
                };
            })
        }
    }
    applyFilterCwallets(value) {
        value = value.trim(); // Remove whitespace
        value = value.toLowerCase();
        this.dataSourceCwallets.filter = value;
    }

}


// WEBPACK FOOTER //
// ./src/app/wallet/wallet.component.ts